import React from 'react';

import { STAGE_STATUS } from '../../../../constants/cycleDetail';

import CircularIcon from '../../../../design-system/CircularIcon/CircularIcon';
import CheckboxLineIcon from '../../../../design-system/Icons/CheckboxLineIcon';
import { FlashlightFillIcon } from '../../../../design-system/Icons';

const StageStatusCard = ({ name, status_key }) => {
    const icon = status_key === STAGE_STATUS.success ? CheckboxLineIcon : FlashlightFillIcon;

    const defaultTitle = 'Almost ready!';
    const title =
        {
            [STAGE_STATUS.in_progress]: 'We’re on it!',
            [STAGE_STATUS.success]: 'This stage is complete!',
        }[status_key] || defaultTitle;

    const defaultDescription = 'Our team is working on this content.';
    const description =
        {
            [STAGE_STATUS.in_progress]: (
                <>
                    Our team is working to build your{' '}
                    <span className="font-body-bold text-body-bold-m">{name}</span> stage.
                </>
            ),
            [STAGE_STATUS.success]: (
                <>
                    You’ve successfully completed your{' '}
                    <span className="font-body-bold text-body-bold-m">{name}</span> stage.
                </>
            ),
        }[status_key] || defaultDescription;

    return (
        <div className="w-full py-[80px] px-5 flex flex-col items-center gap-4">
            <CircularIcon icon={icon} color="neutral" />

            <div className="flex flex-col items-center gap-1 max-w-[500px]">
                <p className="font-heading-bold text-heading-bold-m text-black text-center">
                    {title}
                </p>
                <p className="font-body text-body-regular-m text-black text-center">
                    {description}
                </p>
            </div>
        </div>
    );
};

export default StageStatusCard;
